import {IProduct} from "../../../../../data/interfaces/products";
import {omit} from "lodash";
import {isObjectWithKeys, trimNumberMinMax} from "../../../../../data/utils/calculators";

export const syncDates = async (props, name, value, directions = {forward: true, backward: false}) => {
  const timeOrder = [
    'originTimeOfTakeOff',
    'originTimeOfLanding',
    'checkInDate',
    'checkOutDate',
    'destinationTimeOfTakeOff',
    'destinationTimeOfLanding',
  ]
    .filter(timeOrder => timeOrder in props.values);
  const getPrevious = currentName => timeOrder[timeOrder.indexOf(currentName) - 1];
  const getNext = currentName => timeOrder[timeOrder.indexOf(currentName) + 1];
  const getAll = (currentName, direction: (currentName: string) => string) => {
    const order = [];
    let nextName = direction(currentName);
    if (nextName) {
      order.push(nextName);
      while (nextName = direction(nextName))
        order.push(nextName);
    }
    return order;
  }
  const setDateTime = (name, value) => props.setFieldValue(name, value, false);
  if (typeof value !== 'number') {
    value = value.getTime();
  }

//  await setDateTime(name, value);

  const minute = 1000 * 60;
  if (directions.backward) {
    for (const timeName of getAll(name, getPrevious)) {
      const getCurrentTime = () => props.values[timeName];
      if (!getCurrentTime() || getCurrentTime() > value) {
        await setDateTime(timeName, value);
      }
    }
  }
  if (directions.forward) {
    for (const timeName of getAll(name, getNext)) {
      const getCurrentTime = () => props.values[timeName];
      if (!getCurrentTime() || getCurrentTime() < value) {
        await setDateTime(timeName, value);
      }
    }
  }
};

const moveKeys = (sourceObj = {}, destinationObj = {}, keys = []) => {
  for (const key of keys) {
    if (sourceObj[key]) {
      destinationObj[key] = sourceObj[key];
      delete sourceObj[key];
    }
  }
};
/**
 * Filters product keys
 * @param product
 */
export const filterPublishProductKeys = (unfilteredProduct: Partial<IProduct> & { forms?: any }, finalSubmit = false): Partial<IProduct> => {
  const filteredProduct: Partial<IProduct> = {};
  const product = omit(unfilteredProduct, ['submittedProduct', 'forms', 'previousStep', 'files', 'document', 'skipFilesCheck']);
  for (const key in product) {
    if (product[key] && (isObjectWithKeys(product[key]) || ['id', 'product_type_id', 'productIdentifier', 'status', 'submittedProduct'].includes(key))) {
      filteredProduct[key] = product[key];
      if (isObjectWithKeys(filteredProduct[key])) {
        delete filteredProduct[key].activeStep;
        delete filteredProduct[key].skipFilesCheck;
        if (finalSubmit === true) {
          moveKeys(filteredProduct[key], filteredProduct, ['tags', 'files']);
        }
      }
    }
  }
  return filteredProduct;
};

export const stepFromProps = (props) => {
  if (props.pathname) {
    const step = props.pathname.split("step");
    if (step.length > 0) {
      const activeStep = step
        .map(s => s.replace(/\D+/g, ''))
        .filter(s => s)
        .find(s => !isNaN(s.replace(/\D+/g, '')));
      if (activeStep) {
        return trimNumberMinMax(parseInt(activeStep) - 1);
      }
    }
  }
  return -1;
};


const outsidePersistStore = {};

export const filesToKeys = (files) => {
  return files
    .filter(file => file)
    .map((file, index) => {
      const key = `${index}_${new Date().getTime()}`;
      outsidePersistStore[key] = file;
      return key;
    });
};

export const keysToFiles = (keys) => {
  return keys
    .map(key => outsidePersistStore[key])
    .filter(file => file);
}
